// NETWORK
import RequestRabbit from './RequestRabbit';

// CONFIG
import config from '../Config';
import { getPlatformToken, setPlatformToken } from '../utils/userDevice';

const useSettingsRequest = () => {
  /**
   * Fetch a User's WebSMS settings.
   * @param {Function} errorHandler - Function to handle errors.
   * @returns {Promise<Object>} - User settings data.
   */
  const getSettings = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/users/settings`;
      const options = { method: 'GET' };

      const response = await RequestRabbit.request(url, options, errorHandler);
      return await response?.json();
    } catch (e) {
      errorHandler(e);
    }
  };

  /**
   * Update a User's WebSMS settings.
   * @param {Object} updates - Settings updates.
   * @param {Function} errorHandler - Function to handle errors.
   * @returns {Promise<Object>} - Updated settings response?.
   */
  const updateSettings = async (updates, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/users/settings`;
      const options = {
        method: 'POST',
        body: JSON.stringify(updates),
        headers: { 'Content-Type': 'application/json' },
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      return await response?.json();
    } catch (e) {
      errorHandler(e);
    }
  };

  const associateMfa = async (type, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/session/associate-token`;
      const options = {
        method: 'POST',
        body: JSON.stringify({
          type,
        }),
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      };
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const verifyMfa = async (type, code, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/session/verify-token`;
      const options = {
        method: 'POST',
        body: JSON.stringify({
          type,
          code,
        }),
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      };
      return await RequestRabbit.request(url, options, errorHandler);
    } catch (e) {
      errorHandler(e);
    }
  };

  const disableMfa = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/session/disable-token`;
      const options = { method: 'DELETE' };
      await RequestRabbit.request(url, options, errorHandler);
    } catch (e) {
      errorHandler(e);
    }
  };

  // Export functions as a module
  return {
    getSettings,
    updateSettings,
    associateMfa,
    verifyMfa,
    disableMfa,
  };
};

export default useSettingsRequest;
